import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { OceanCanvas } from "@/components/OceanCanvas";
import { Intro } from "@/components/Intro";
import { Marquee } from "@/components/Marquee";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Industries } from "@/components/Industries";
import { Founder } from "@/components/Founder";
import { Team } from "@/components/Team";
import { Stats } from "@/components/Stats";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App relative text-[#E8F1F5] min-h-screen">
      <OceanCanvas />
      <Intro />
      <div className="fixed inset-0 -z-[5] pointer-events-none">
        <div className="absolute top-[-10%] left-[10%] w-[500px] h-[500px] rounded-full bg-[#00F2FE]/[0.06] blur-[120px] animate-float-slow" />
        <div className="absolute bottom-[5%] right-[5%] w-[600px] h-[600px] rounded-full bg-[#10E59A]/[0.05] blur-[140px] animate-float-slow" style={{ animationDelay: "-3s" }} />
      </div>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Industries />
        <Founder />
        <Team />
        <Stats />
        <Marquee />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <ChatWidget />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
